// extracted by mini-css-extract-plugin
export default {"bEntityTag":"BEntityTag-module_bEntityTag_d1009404"};